import "./scss/app.scss"
import toastr from 'toastr'
import AliplayerDanmuComponent from "./AliplayerDanmuComponent";

window.toastr = toastr

let mySettings = {
    autoplay: true,
    components: [{
        name: 'AliplayerDanmuComponent',
        type: AliplayerDanmuComponent,
        args: []
    }]
}

let settings = {...window.settings, ...mySettings}
settings.autoplay = false
settings.x5_type = "h5"

let player = new Aliplayer(settings, function (player) {
    let $video = $("video");
    $video.removeAttr("x5-playsinline")
    $("#login_dialog").modal({
        backdrop: "static",
    })
});


function send() {
    let value = $("#danmu_send_input").val()
    if (!value) {
        return
    }
    let destination = `/app/course/${PageContext.courseId}/post-danmu`;
    let damnu = {
        time: player.getCurrentTime(),
        text: value,
        user: currentUser
    };
    client.publish({
        destination: destination, body: JSON.stringify(damnu)
    });
    player.getComponent('AliplayerDanmuComponent').sendTxt(damnu.user.name + "@" + damnu.user.company + ":" + damnu.text, 0xffff33)
    $("#danmu_send_input").val("")
    // $("#danmu_send_input").focus()
}

$("#danmu_send_btn").click((e) => {
    e.preventDefault()
    send();
})

$('#danmu_send_input').keypress(function (e) {
    if (e.which == 13) {
        send();
        return false;    //<---- Add this line
    }
});

$("#danmu_send_i1_btn").click((e) => {
    e.preventDefault()
    $("#danmu_send_input").val($("#danmu_send_input").val() + "🚀")
    // $("#danmu_send_input").focus()

})
$("#danmu_send_i2_btn").click((e) => {
    e.preventDefault()
    $("#danmu_send_input").val($("#danmu_send_input").val() + "🚢")
    // $("#danmu_send_input").focus()
})

const client = new StompJs.Client({
    debug: function (str) {
        // console.log(str);
    },
    reconnectDelay: 5000,
    heartbeatIncoming: 4000,
    heartbeatOutgoing: 4000
});

client.webSocketFactory = function () {
    // Note that the URL is different from the WebSocket URL
    return new SockJS(QUARK_CONTEXT_PATH + 'ws');
};

client.onConnect = function (frame) {
    // Do something, all subscribes must be done is this callback
    // This is needed because this will be executed after a (re)connect
    client.subscribe(`/topic/course/${PageContext.courseId}/danmu-approved`, (payload) => {
        // console.log(payload);
        let res = JSON.parse(payload.body)
        res.list.forEach((item) => {
            if (!(item.user.name === currentUser.name && item.user.company === currentUser.company)) {
                player.getComponent('AliplayerDanmuComponent').sendTxt(item.user.name + "@" + item.user.company + ":" + item.text)
            }
        })
    });
};

client.onStompError = function (frame) {
    // Will be invoked in case of error encountered at Broker
    // Bad login/passcode typically will cause an error
    // Complaint brokers will set `message` header with a brief message. Body may contain details.
    // Compliant brokers will terminate the connection after any error
    console.log('Broker reported error: ' + frame.headers['message']);
    console.log('Additional details: ' + frame.body);
};

client.activate();


// setTimeout(() => {
//     $("#login_dialog").modal({
//         backdrop: "static",
//     })
// }, 2000)

// $("#login_dialog").modal('show')

let currentUser = {}
currentUser.name = "eric"
currentUser.company = "test"

$("#login_form_submit").click(() => {

    let name = $("#login_form_name").val()
    let company = $("#login_form_company").val()

    let errorMessage = []
    if (!name || name.length > 100) {
        errorMessage.push('姓名不能为空')
    }

    if (!company || company.length > 100) {
        errorMessage.push('公司不能为空')
    }

    if (errorMessage.length) {
        toastr.error(errorMessage.join(", "))
        return
    }
    currentUser.name = name
    currentUser.company = company
    $("#login_dialog").modal("hide")


    let $video = $("video");
    $video.removeAttr("x5-playsinline")
    player.play()


})

//
// setTimeout(() => {
//     let $video = $("video");
//     $video.removeAttr("x5-playsinline")
//     // alert($video.get(0).outerHTML)
// }, 2000)


export {
    currentUser
}